import React, { useEffect, useState } from 'react';
import { LayoutTemplate } from 'lucide-react';
import { api } from '../../lib/api';

// "Insert template ▾" — a small select that loads saved templates once and
// hands the chosen one back. Used by the broadcast editor and the composer.
export default function TemplatePicker({ onPick, disabled = false, label = 'Insert template', className = '' }) {
  const [templates, setTemplates] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let alive = true;
    const p = api.get('/api/admin/communications/templates');
    if (!p || typeof p.then !== 'function') return undefined;
    p.then((d) => { if (alive) setTemplates(d?.templates || []); })
      .catch((err) => { if (alive) { setTemplates([]); setError(err?.message || 'Could not load templates'); } });
    return () => { alive = false; };
  }, []);
  if (templates && templates.length === 0 && !error) return null;
  return (
    <label className={`inline-flex items-center gap-1.5 text-[12px] text-gray-400 ${className}`} title={error || undefined}>
      <LayoutTemplate className="w-3.5 h-3.5" aria-hidden="true" />
      <select
        aria-label={label}
        data-testid="template-picker"
        disabled={disabled || !templates}
        value=""
        onChange={(e) => {
          const t = templates?.find((x) => x.id === e.target.value);
          if (t) onPick?.(t);
        }}
        className="bg-white/[0.03] border border-white/[0.08] rounded-lg px-2 py-1 text-[12px] text-gray-200 focus:outline-none focus:border-[#B0FC38]/40 disabled:opacity-50"
      >
        <option value="">{templates ? `${label}…` : 'Loading templates…'}</option>
        {(templates || []).map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>
    </label>
  );
}
